/* global $ */

const $table = $('.adv-table');
const $sort = $('.js-adv-table-sort');
const $sortHead = $('.js-adv-table-sort-head');

const advTable = {
  initialize() {
    if ($table.length) {
      // Get the initial sorting from the filter select
      const sort = $sort.val().split(':');

      // Separate the initial filter in a sort on name and direction
      [this.sort, this.sortDirection] = sort;

      // Set the arrows and states correctly on the table heads
      this.outputSortToTableHead();

      // Create events for further instructions
      this.createEvents();
    }
  },

  /**
   * Create events for the table
   * @return {void}
   */
  createEvents() {
    // Listen for clicks on the table heads
    $sortHead.on('click', (e) => {
      const { name } = $(e.currentTarget).data();

      // If we're already sorting on this name, we reverse the direction
      if (name === this.sort) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';

      // If we've clicked a new sorting option, we set it and reset the direction to ascending
      } else {
        this.sort = name;
        this.sortDirection = 'asc';
      }

      // Output new sort to the input field for the filter to pick it up
      $sort.val(`${this.sort}:${this.sortDirection}`).trigger('change');

      // Display the correct arrows and states on the table heads
      this.outputSortToTableHead();
    });
  },

  /**
   * Update the table heads with the change in sorting
   * @return {void}
   */
  outputSortToTableHead() {
    // Remove all state classes
    $sortHead.removeClass('is-sorted is-sorted-asc is-sorted-desc');

    // Get the column that is sorted by
    const $sortedHead = $sortHead.filter(`[data-name="${this.sort}"]`);

    // Add the is-sorted class for styling
    $sortedHead.addClass('is-sorted');

    // Add the is-sorted-(asc/desc) for styling
    $sortedHead.addClass(`is-sorted-${this.sortDirection}`);
  },
};

export default advTable;
